import * as React from "react";
import { useCallback } from "react";

import { FieldGroup } from "affinityUI/form/components";

import { DateFiledTypes, DatePart } from "./datePart";

export type DateParts = Partial<Record<DateFiledTypes, Maybe<string>>>;

export const DateInput: React.FC<{
  onChange: (value: DateParts) => void;
  value?: Maybe<DateParts>;
  error?: unknown;
  name: string;
}> = ({ onChange, error, value, name }) => {
  const handleChange = useCallback(
    (fieldData: { name: string; value?: string }) => {
      const newState = { ...value, [fieldData.name]: fieldData.value };
      onChange(newState);
    },
    [value, onChange]
  );

  return (
    <FieldGroup>
      <DatePart
        error={error}
        name={name}
        type={DateFiledTypes.DAY}
        onChange={handleChange}
        defaultValue={value?.day ?? undefined}
      />
      <DatePart
        name={name}
        error={error}
        type={DateFiledTypes.MONTH}
        onChange={handleChange}
        defaultValue={value?.month ?? undefined}
      />
      <DatePart
        name={name}
        error={error}
        type={DateFiledTypes.YEAR}
        onChange={handleChange}
        defaultValue={value?.year ?? undefined}
      />
    </FieldGroup>
  );
};
